<router-outlet></router-outlet>
<ngx-spinner bdColor = "rgb(0 0 0 / 85%)" 
    size = "medium" 
    type = "square-jelly-box" 
    [fullScreen] = "true" 
    template = '<iframe src="https://illpeoplemusic-v2-asserts-dev.s3.ap-south-1.amazonaws.com/imges/imgs/DevLoader/index.html" frameborder="0" class="ifame-loader-set"></iframe>'>
</ngx-spinner>
<p-toast position="bottom-left"
[preventOpenDuplicates]="false"
[showTransformOptions]="'translateY(100%)'" 
[showTransitionOptions]="'3ms'" 
[sticky]="true"
[showTransformOptions]="'translateX(100%)'"></p-toast>